import React, { useEffect, useState } from "react";
import { useTable, useSortBy, Column } from "react-table";
import { RoleRow } from "../../types";
import { TableBurgerIcon } from "../../icons/tableBurger";
import Paginator from "../paginator";
import { CellSortIcon } from "../../icons/sort";
import { backend, Role, SourceData } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { actions, RootState } from "../../state/reducer";
import { toast } from "sonner";
import { closeModal, openModal } from "../../state/modalSlice";
import UpdateRoleModal from "../../modals/roles/updateRole";
import { generateRandomString } from "../../utils";
import ConfirmationModal from "../../modals/yesNoWindow";

interface SourceTableProps {
  columns: Column<SourceData>[];
  data: SourceData[];
}

const tableGridTemplate = "1fr 2fr 4fr 2fr";

const SourcesTable: React.FC<SourceTableProps> = ({ columns, data }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable<SourceTableProps>({ columns, data }, useSortBy);

  return (
    <div {...getTableProps()} style={{ display: "grid", gap: "10px" }}>
      {/* Заголовок таблицы */}
      <div
        className="tableHeading"
        style={{
          display: "grid",
          gridTemplateColumns: tableGridTemplate,
        }}
      >
        {headerGroups.map((headerGroup) =>
          headerGroup.headers.map((column) => (
            <div
              {...column.getHeaderProps(column.getSortByToggleProps())}
              style={{ cursor: column.canSort ? "pointer" : "default" }}
            >
              {column.render("Header")}
              {console.log(typeof column.Header)}
              {column.Header !== "" && typeof column.Header === "string" ? (
                <CellSortIcon
                  width={8}
                  height={5}
                  classNames={
                    column.isSortedDesc
                      ? ["sortedDesc", "grayFilled"]
                      : ["grayFilled"]
                  }
                />
              ) : null}
            </div>
          ))
        )}
      </div>

      {/* Тело таблицы */}
      <div {...getTableBodyProps()} style={{ display: "grid", gap: "10px" }}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <div
              {...row.getRowProps()}
              style={{
                display: "grid",
                gridTemplateColumns: tableGridTemplate,
                padding: "10px 0",
                borderBottom: "1px solid #ccc",
              }}
            >
              {row.cells.map((cell: any) => (
                <div {...cell.getCellProps()}>{cell.render("Cell")}</div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const SourceListTable = (props: { search: string }) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [data, setData] = useState<SourceData[]>([]);
  const rights = State.rights;

  useEffect(() => {
    backend.getCustomerSources().then((res) => {
      setData(res.sources)
    }).catch((e) => {
      toast("Не удалось загрузить список")
    })
  }, [State.selectedItem])
  /* { group: "Отдел 1", role: "Старший аналитик" } */
  const columns: Column<Role>[] = [
    { Header: "Id", accessor: "id", canSort: true },
    { Header: "Название", accessor: "name", canSort: true },
    { Header: "Ключ API", accessor: "api_key", canSort: true },
    {
      Header: "",
      accessor: "action",
      Cell: ({ row }: any) => { 
        const handleDeleteSource = () => {
          // ConfirmationModal
          dispatch(openModal({ component: ConfirmationModal, context: {
            user_id: row.original.short?.id,
            question: `Удалить источник ${row.original.name}?`,
            onConfirm: () => {
              backend.deleteCustomerSource({api_key: row.original.api_key}).then(() => {
                dispatch(actions.selectItem(generateRandomString(3)))
                toast("Удалено")
              }).catch(() => {
                toast("Ошибка")
              })
            },
            onDecline: () => {
              toast("Действие отменено")
            },
            closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
          }, }));
        }
        return (
        rights && rights.rang < 3 && <div className="aBtn userRoleTableText red" onClick={handleDeleteSource}>Удалить</div>
      )},
    }
  ];

  return (
    <div className="tableContainer">
      <SourcesTable data={data} columns={columns} />
      {/* <Paginator /> */}
    </div>
  );
};

export default SourceListTable;
